import angular from 'angular';
import { CartItemEventDirectiveModule } from './event/event.directive';

CartItemDirective.$inject = [];
function CartItemDirective() {
  CartItemController.$inject = ['$scope'];
  function CartItemController($scope) {
    $scope.cartItem = {};
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/cartItem/cartItem.tpl.html',
    scope: {},

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: CartItemController,
  };
}

export const CartItemDirectiveModule = angular
  .module('acme.common.directive.cartItem', [CartItemEventDirectiveModule])
  .directive('cartItem', CartItemDirective).name;
